import React from 'react';
import { partners } from '../mock/mock';

const Partners = () => {
  const loop = [...partners, ...partners];
  return (
    <section className="bg-slate-50 py-12 border-y border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-center text-sm font-medium text-slate-500 uppercase tracking-wider mb-6">
          We Associated with following Insurance Companies
        </p>
        <div className="relative overflow-hidden">
          <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-slate-50 to-transparent z-10" />
          <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-slate-50 to-transparent z-10" />
          <div className="flex gap-8 animate-marquee whitespace-nowrap">
            {loop.map((p, i) => (
              <div key={i} className="shrink-0 bg-white rounded-xl border border-slate-100 px-6 py-4 min-w-[160px] flex items-center justify-center text-sm font-semibold text-slate-600 hover:text-[#00B48E] hover:border-emerald-200 transition-colors">
                {p}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partners;
